import React from 'react';
import { Line, Doughnut } from 'react-chartjs-2';
import {
    FiGlobe,
    FiFolder,
    FiBriefcase,
    FiMail,
    FiUsers,
    FiTrendingUp,
    FiPercent,
    FiCheckCircle,
} from 'react-icons/fi';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import './AdminDashboard.scss';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ArcElement);

// Dữ liệu thống kê fix cứng
const statsData = {
    languages: 7,
    newsCategories: 12,
    recruitments: 24,
    contacts: 156,
    totalUsers: 3840,
    pageViews: 12500,
    conversionRate: '4.8%',
    activeItems: 89,
};

const lineChartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
        {
            label: 'Visitors',
            data: [1200, 1900, 1700, 2100, 2400, 2800, 3100, 3400, 3700, 4200, 4600, 5100],
            borderColor: '#4f46e5',
            backgroundColor: 'rgba(79, 70, 229, 0.05)',
            borderWidth: 2,
            tension: 0.4,
            fill: true,
            pointBackgroundColor: '#4f46e5',
            pointHoverRadius: 6,
        },
    ],
};

const doughnutData = {
    labels: ['Languages', 'News Categories', 'Recruitments', 'Contacts'],
    datasets: [
        {
            data: [7, 12, 24, 156],
            backgroundColor: ['#4f46e5', '#06b6d4', '#f59e0b', '#10b981'],
            borderWidth: 0,
        },
    ],
};

const Dashboard = () => {
    return (
        <div className="dashboard">
            <div className="welcome-section">
                <div className="welcome-text">
                    <h1>Overview Dashboard</h1>
                    <p>HSV Health Solutions Vietnam — Admin Management Console</p>
                </div>
                <div className="welcome-date">
                    <span>Active Session</span>
                </div>
            </div>

            <div className="stats-grid">
                <div className="stat-card languages">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiGlobe /></div>
                        <span className="trend positive">+14%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.languages}</h3>
                        <p>Languages</p>
                    </div>
                </div>

                <div className="stat-card news">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiFolder /></div>
                        <span className="trend positive">+8%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.newsCategories}</h3>
                        <p>News Categories</p>
                    </div>
                </div>

                <div className="stat-card recruitments">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiBriefcase /></div>
                        <span className="trend positive">+25%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.recruitments}</h3>
                        <p>Recruitments</p>
                    </div>
                </div>

                <div className="stat-card contacts">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiMail /></div>
                        <span className="trend positive">+18%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.contacts}</h3>
                        <p>Contacts</p>
                    </div>
                </div>

                <div className="stat-card users">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiUsers /></div>
                        <span className="trend positive">+12%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.totalUsers.toLocaleString()}</h3>
                        <p>Total Users</p>
                    </div>
                </div>

                <div className="stat-card views">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiTrendingUp /></div>
                        <span className="trend positive">+32%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.pageViews.toLocaleString()}</h3>
                        <p>Page Views</p>
                    </div>
                </div>

                <div className="stat-card rate">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiPercent /></div>
                        <span className="trend negative">-0.4%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.conversionRate}</h3>
                        <p>Conversion Rate</p>
                    </div>
                </div>

                <div className="stat-card active-items">
                    <div className="card-header">
                        <div className="icon-wrapper"><FiCheckCircle /></div>
                        <span className="trend positive">+5%</span>
                    </div>
                    <div className="card-body">
                        <h3>{statsData.activeItems}</h3>
                        <p>Active Items</p>
                    </div>
                </div>
            </div>

            <div className="charts-row">
                <div className="chart-card visitor-chart">
                    <div className="chart-header">
                        <h3>Visitors Trend</h3>
                        <span className="subtitle">Monthly traffic analysis</span>
                    </div>
                    <div className="chart-body">
                        <Line data={lineChartData} options={{ responsive: true, maintainAspectRatio: false }} />
                    </div>
                </div>
                <div className="chart-card distribution-chart">
                    <div className="chart-header">
                        <h3>Modules Distribution</h3>
                        <span className="subtitle">Entity representation</span>
                    </div>
                    <div className="chart-body">
                        <Doughnut data={doughnutData} options={{ cutout: '70%', plugins: { legend: { position: 'bottom', labels: { boxWidth: 12, padding: 16 } } } }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;